// Import jQuery from window
import $ from 'jquery';

/*
* rollover
*/

$(function(){
	$("a,button,.op,ul.bxslider01 li img").hover(function(){
		$(this).stop().animate({"opacity":"0.7"});
	},function(){
		$(this).stop().animate({"opacity":"1"});
	});
	$(".pager a,.relation .inner .parts div p a,#breadcrumb ul li a,.bg_w .more a,.relation .inner .parts .ttl2 a,.hobby_block .inner .ttl a").hover(function(){
		$(this).stop().animate({"opacity":"1"});
	});
});

/*
* scroll
*/
new function(){
	var attr ="data-tor-smoothScroll";//for html5 , if you can't use html5 , this value change "class"
	var attrPatt = /noSmooth/;
	var d = document;//document short cut
	var scZoom = $("html").css("zoom");
	
	/*
	 *add Event
	  -------------------------------------------------*/
	function addEvent(elm,listener,fn){
		try{ // IE
			elm.addEventListener(listener,fn,false);
		}catch(e){
			elm.attachEvent(
				"on"+listener
				,function(){
					fn.apply(elm,arguments)
				}
			);
		}
	}

	/*
	 *Start SmoothScroll
	  -------------------------------------------------*/
	function SmoothScroll(a){
		if(d.getElementById(a.rel.replace(/.*\#/,""))){
			var e = d.getElementById(a.rel.replace(/.*\#/,""));
		}else{
			return;
		}


		//Move point
		var end=e.offsetTop
		var docHeight = d.documentElement.scrollHeight;
		var winHeight = window.innerHeight || d.documentElement.clientHeight
		if(docHeight-winHeight<end){
			var end = docHeight-winHeight;
		}
		
		//Current Point
		var start=window.pageYOffset || d.documentElement.scrollTop || d.body.scrollTop || 0;
		
		
		var flag=(end<start)?"up":"down";

		function scrollMe(start,end,flag) {
			setTimeout(
				function(){
					if(flag=="up" && start >= end){
						start=start-(start-end)/20-1;
						window.scrollTo(0,start)
						scrollMe(start,end,flag);
					}else if(flag=="down" && start <= end){
						start=start+(end-start)/20+1;
						window.scrollTo(0,start)
						scrollMe(start,end,flag);
					}else{
						scrollTo(0,end);
					}
					return ;
				}
				,10
			);
			
		}

		scrollMe(start,end,flag);
		
	}

/*
	 *Add SmoothScroll
	  -------------------------------------------------*/
	addEvent(window,"load",function(){
		var anchors = d.getElementsByTagName("a");
		for(var i = 0 ,len=anchors.length; i<len ; i++){
			if(!attrPatt.test(anchors[i].getAttribute(attr)) &&
				anchors[i].href.replace(/\#[a-zA-Z0-9_]+/,"") == location.href.replace(/\#[a-zA-Z0-9_]+/,"")){
				anchors[i].rel = anchors[i].href;
				anchors[i].href = "javascript:void(0)";
				anchors[i].onclick=function(){SmoothScroll(this)}
			}
		}
	});
}

/*
* font size swicher and css browser selector - removed (not needed)
*/


/*
* embed_article
*/

$(document).ready(function() {
    var $template = $('#template-article > div').clone();
    $(".embed-article").each(function(i, e) {
        var id = $(e).data("id");
        $.ajax({
            url: "/api/article/" + id,
            data: { site: "pc" },
            timeout: 10000
        }).done(function(data) {
            $("a", $template).attr("href", data.url);
            $(".embed-icon", $template).attr("src", data.icon_url);
            $(".embed-thumbnail", $template).attr("src", data.image_url);
            $(".embed-title", $template).text(data.title);
            $(".embed-description", $template).text(data.description);
            $(e).append($template.html());
        });
    });
});

/*
* Main and Thumbnail Carousel - Scroll-based seamless infinite loop
*/
function initCarousel() {
    console.log('PC Carousel: Init function called');
    const mainCarousel = document.querySelector('.main-carousel');
    const thumbnailCarousel = document.querySelector('.thumbnail-carousel');

    if (!mainCarousel || !thumbnailCarousel) {
        console.log('PC Carousel: Elements not found, exiting');
        return;
    }

    const mainItems = Array.from(mainCarousel.querySelectorAll('.main-carousel-item'));
    const thumbnailItems = Array.from(thumbnailCarousel.querySelectorAll('.thumbnail-item'));

    if (mainItems.length === 0 || thumbnailItems.length === 0) return;

    const originalMainCount = mainItems.length;
    const originalThumbnailCount = thumbnailItems.length;

    // Clone items for infinite loop - main carousel
    mainItems.forEach(item => {
        const clone = item.cloneNode(true);
        mainCarousel.appendChild(clone);
    });

    // Clone items for infinite loop - thumbnail carousel
    thumbnailItems.forEach(item => {
        const clone = item.cloneNode(true);
        thumbnailCarousel.appendChild(clone);
    });

    let currentIndex = 0;
    let autoScrollInterval = null;
    let thumbnailAutoScrollInterval = null;
    let isScrolling = false;

    // Create navigation buttons
    const thumbnailWrapper = document.querySelector('.thumbnail-carousel-wrapper');
    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');

    prevBtn.className = 'thumbnail-nav thumbnail-prev';
    nextBtn.className = 'thumbnail-nav thumbnail-next';
    prevBtn.innerHTML = '‹';
    nextBtn.innerHTML = '›';

    thumbnailWrapper.appendChild(prevBtn);
    thumbnailWrapper.appendChild(nextBtn);

    // Get all items including clones
    const allMainItems = mainCarousel.querySelectorAll('.main-carousel-item');
    const allThumbnailItems = thumbnailCarousel.querySelectorAll('.thumbnail-item');

    // Scroll main carousel to specific index
    function scrollToIndex(index) {
        if (isScrolling) return;

        const itemWidth = mainItems[0].offsetWidth;
        mainCarousel.scrollTo({
            left: itemWidth * index,
            behavior: 'smooth'
        });
        currentIndex = index;
        updateThumbnailActive();
    }

    // Update active thumbnail
    function updateThumbnailActive() {
        const actualIndex = currentIndex % originalMainCount;
        allThumbnailItems.forEach((item, idx) => {
            const itemIndex = idx % originalThumbnailCount;
            if (itemIndex === actualIndex) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    // Handle main carousel scroll end - reset if needed
    let mainScrollTimeout;
    mainCarousel.addEventListener('scroll', function() {
        clearTimeout(mainScrollTimeout);
        mainScrollTimeout = setTimeout(() => {
            const itemWidth = mainItems[0].offsetWidth;
            const scrollLeft = mainCarousel.scrollLeft;
            const currentPos = Math.round(scrollLeft / itemWidth);

            // If we're in the cloned section, reset to original
            if (currentPos >= originalMainCount) {
                mainCarousel.style.scrollBehavior = 'auto';
                mainCarousel.scrollLeft = 0;
                currentIndex = 0;
                mainCarousel.style.scrollBehavior = 'smooth';
                updateThumbnailActive();
            }
        }, 150);
    });

    // Handle thumbnail carousel scroll end - reset if needed
    let thumbnailScrollTimeout;
    thumbnailCarousel.addEventListener('scroll', function() {
        clearTimeout(thumbnailScrollTimeout);
        thumbnailScrollTimeout = setTimeout(() => {
            const itemWidth = 200 + 13;
            const scrollLeft = thumbnailCarousel.scrollLeft;
            const maxOriginalScroll = itemWidth * originalThumbnailCount;

            // If we're past the original section, reset
            if (scrollLeft >= maxOriginalScroll - 10) {
                thumbnailCarousel.style.scrollBehavior = 'auto';
                thumbnailCarousel.scrollLeft = 0;
                thumbnailCarousel.style.scrollBehavior = 'smooth';
            }
        }, 150);
    });

    // Auto scroll main carousel
    function autoScroll() {
        currentIndex++;
        scrollToIndex(currentIndex);
    }

    // Auto scroll thumbnail carousel
    function thumbnailAutoScroll() {
        const scrollAmount = 200 + 13; // item width + gap
        thumbnailCarousel.scrollBy({ left: scrollAmount * 3, behavior: 'smooth' });
    }

    // Start/stop auto scroll
    function startAutoScroll() {
        if (autoScrollInterval) return;
        autoScrollInterval = setInterval(autoScroll, 7000);
    }

    function stopAutoScroll() {
        if (autoScrollInterval) {
            clearInterval(autoScrollInterval);
            autoScrollInterval = null;
        }
    }

    function startThumbnailAutoScroll() {
        if (thumbnailAutoScrollInterval) return;
        thumbnailAutoScrollInterval = setInterval(thumbnailAutoScroll, 7000);
    }

    function stopThumbnailAutoScroll() {
        if (thumbnailAutoScrollInterval) {
            clearInterval(thumbnailAutoScrollInterval);
            thumbnailAutoScrollInterval = null;
        }
    }

    // Thumbnail click handler
    thumbnailItems.forEach((item, index) => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            stopAutoScroll();
            stopThumbnailAutoScroll();
            scrollToIndex(index);
            setTimeout(() => {
                startAutoScroll();
                startThumbnailAutoScroll();
            }, 5000);
        });
    });

    // Navigation buttons
    prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        stopAutoScroll();
        stopThumbnailAutoScroll();
        const scrollAmount = 200 + 13;
        thumbnailCarousel.scrollBy({ left: -scrollAmount * 3, behavior: 'smooth' });
        setTimeout(() => {
            startAutoScroll();
            startThumbnailAutoScroll();
        }, 5000);
    });

    nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        stopAutoScroll();
        stopThumbnailAutoScroll();
        const scrollAmount = 200 + 13;
        thumbnailCarousel.scrollBy({ left: scrollAmount * 3, behavior: 'smooth' });
        setTimeout(() => {
            startAutoScroll();
            startThumbnailAutoScroll();
        }, 5000);
    });

    // Pause on hover
    mainCarousel.addEventListener('mouseenter', () => {
        stopAutoScroll();
        stopThumbnailAutoScroll();
    });
    mainCarousel.addEventListener('mouseleave', () => {
        startAutoScroll();
        startThumbnailAutoScroll();
    });
    thumbnailCarousel.addEventListener('mouseenter', () => {
        stopAutoScroll();
        stopThumbnailAutoScroll();
    });
    thumbnailCarousel.addEventListener('mouseleave', () => {
        startAutoScroll();
        startThumbnailAutoScroll();
    });

    // Initialize
    updateThumbnailActive();
    startAutoScroll();
    startThumbnailAutoScroll();
}

// Call init function immediately or after DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
} else {
    // DOM is already ready, call immediately
    initCarousel();
}

/*
* matchHeight - Native implementation
*/
function matchHeight() {
    // 診断結果ページでは適用しない
    if (document.getElementById('shindan-result')) return;

    const elements = document.querySelectorAll('.hobby_block .inner');
    if (elements.length === 0) return;

    // Reset heights
    elements.forEach(el => el.style.height = 'auto');

    // Find max height
    let maxHeight = 0;
    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
    });

    // Set all to max height
    elements.forEach(el => el.style.height = maxHeight + 'px');
}

// Run on load and resize
window.addEventListener('load', matchHeight);
window.addEventListener('resize', matchHeight);

/*
* Native JS carousel for tag images
*/
document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.tag-carousel');
    if (!carousel) return;

    const wrapper = carousel.parentElement;
    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');

    prevBtn.className = 'carousel-btn carousel-prev';
    nextBtn.className = 'carousel-btn carousel-next';
    prevBtn.innerHTML = '‹';
    nextBtn.innerHTML = '›';

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    const scrollAmount = 700;
    prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
});

/*
* Native JS carousel for article images - SEAMLESS INFINITE LOOP VERSION
*/
document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.article-carousel');
    if (!carousel) return;

    const wrapper = carousel.parentElement;
    const items = Array.from(carousel.querySelectorAll('.inner'));

    if (items.length === 0) return;

    const originalCount = items.length;

    // Clone items for infinite loop
    items.forEach(item => {
        const clone = item.cloneNode(true);
        carousel.appendChild(clone);
    });

    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');

    prevBtn.className = 'carousel-btn carousel-prev';
    nextBtn.className = 'carousel-btn carousel-next';
    prevBtn.innerHTML = '‹';
    nextBtn.innerHTML = '›';

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    const scrollAmount = 240;
    let autoScrollInterval = null;

    // Handle scroll end - reset if needed
    let scrollTimeout;
    carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            const scrollLeft = carousel.scrollLeft;
            const maxOriginalScroll = scrollAmount * originalCount;

            // If we're in the cloned section, reset to original
            if (scrollLeft >= maxOriginalScroll - 10) {
                carousel.style.scrollBehavior = 'auto';
                carousel.scrollLeft = 0;
                carousel.style.scrollBehavior = 'smooth';
            }
        }, 150);
    });

    function autoScroll() {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    function startAutoScroll() {
        if (autoScrollInterval) return;
        autoScrollInterval = setInterval(autoScroll, 4000);
    }

    function stopAutoScroll() {
        if (autoScrollInterval) {
            clearInterval(autoScrollInterval);
            autoScrollInterval = null;
        }
    }

    prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        stopAutoScroll();
        setTimeout(startAutoScroll, 5000);
    });
    nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        stopAutoScroll();
        setTimeout(startAutoScroll, 5000);
    });

    carousel.addEventListener('mouseenter', stopAutoScroll);
    carousel.addEventListener('mouseleave', startAutoScroll);

    // Start auto-scroll
    startAutoScroll();
});

/*
* Native JS carousel for footer main tags (#carousel) - SEAMLESS INFINITE LOOP VERSION
*/
(function() {
    // Wait for page load
    window.addEventListener('load', function() {
        setTimeout(function() {
            const carousels = document.querySelectorAll('#carousel .carousel');
            if (carousels.length === 0) return;

            carousels.forEach(function(carousel) {
                const wrapper = carousel.parentElement;
                const items = Array.from(carousel.children);

                if (items.length === 0) return;

                const originalCount = items.length;

                // Clone all items for infinite loop
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    carousel.appendChild(clone);
                });

                const prevBtn = document.createElement('button');
                const nextBtn = document.createElement('button');

                prevBtn.className = 'carousel-btn carousel-prev';
                nextBtn.className = 'carousel-btn carousel-next';
                prevBtn.innerHTML = '‹';
                nextBtn.innerHTML = '›';

                wrapper.appendChild(prevBtn);
                wrapper.appendChild(nextBtn);

                const scrollAmount = 236; // 218px (image width) + 18px (gap)
                let autoScrollInterval = null;

                // Handle scroll end - reset if needed
                let scrollTimeout;
                carousel.addEventListener('scroll', function() {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(() => {
                        const scrollLeft = carousel.scrollLeft;
                        const maxOriginalScroll = scrollAmount * originalCount;

                        // If we're in the cloned section, reset to original
                        if (scrollLeft >= maxOriginalScroll - 10) {
                            carousel.style.scrollBehavior = 'auto';
                            carousel.scrollLeft = 0;
                            carousel.style.scrollBehavior = 'smooth';
                        }
                    }, 150);
                });

                function autoScroll() {
                    carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                }

                function startAutoScroll() {
                    if (autoScrollInterval) return;
                    autoScrollInterval = setInterval(autoScroll, 4000);
                }

                function stopAutoScroll() {
                    if (autoScrollInterval) {
                        clearInterval(autoScrollInterval);
                        autoScrollInterval = null;
                    }
                }

                prevBtn.onclick = function() {
                    carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                    stopAutoScroll();
                };

                nextBtn.onclick = function() {
                    carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    stopAutoScroll();
                };

                carousel.onmouseenter = stopAutoScroll;
                carousel.onmouseleave = startAutoScroll;

                // Start auto-scroll
                startAutoScroll();
            });
        }, 2000);
    });
})();

/*
* Category detail toggle
*/
document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.querySelector('.category_detail_toggle');
    const categoryDetail = document.querySelector('.category_detail');
    const toggleText = document.querySelector('.category_detail_toggle .toggle_text');

    if (!toggleBtn || !categoryDetail) return;

    toggleBtn.addEventListener('click', function() {
        categoryDetail.classList.toggle('is_open');

        if (categoryDetail.classList.contains('is_open')) {
            toggleText.textContent = '閉じる';
        } else {
            toggleText.textContent = '特徴・メリット・探し方を見る';
        }
    });
});
